var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 10 10","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"5","cy":"5","r":"5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }